<template>
  <th-modal
    name="session-expired-modal"
    width="400px"
    modal-class="session-expired-modal"
    body-class="session-expired-body"
    data-testid="two-fa-session-expired-modal"
    @close="handleModalClose"
  >
    <div
      class="session-expired-content"
      data-testid="two-fa-session-expired-content"
    >
      <h5
        class="u-heading-5 session-expired-title"
        data-testid="two-fa-session-expired-title"
      >
        {{ $t('pages.auth.session_expired.title') }}
      </h5>
      <p
        class="u-details-field-body-2 session-expired-message"
        data-testid="two-fa-session-expired-message"
      >
        {{
          $t('pages.auth.session_expired.message', { timeout: sessionTimeout })
        }}
      </p>
    </div>

    <template #footer>
      <div
        class="flex w-full flex-wrap justify-end items-start content-start gap-x-3 gap-y-3"
        data-testid="two-fa-session-expired-footer"
      >
        <router-link
          to="/logout?redirect=/login"
          data-testid="two-fa-session-expired-signin-button"
          @click="trackLogout"
        >
          <el-button type="danger">
            {{ $t('pages.auth.session_expired.buttons.sign_in') }}
          </el-button>
        </router-link>
      </div>
    </template>
  </th-modal>
</template>

<script>
import ThModal from '@shared/components/modal'
import AuthService from '@shared/plugins/auth'

export default {
  name: 'SessionExpiredModal',
  components: {
    ThModal
  },
  data() {
    return {
      allowClose: false,
      overlayClickHandler: null
    }
  },
  computed: {
    sessionTimeout() {
      return AuthService.getSessionTimeoutMinutes()
    }
  },
  mounted() {
    this.$thModal.listen(this.handleModalToggle)
  },
  beforeUnmount() {
    this.cleanupOverlayHandler()
  },
  methods: {
    handleModalToggle(name, state) {
      if (name !== 'session-expired-modal') return

      if (state) {
        this.$nextTick(() => this.setupOverlayProtection())
      } else {
        this.cleanupOverlayHandler()
      }
    },
    setupOverlayProtection() {
      const modal = document.querySelector('.session-expired-modal')
      if (!modal) return

      const wrapper = modal.closest('.th-modal-wrapper')
      if (!wrapper) return

      const overlay = wrapper.querySelector('.th-modal-overlay')
      if (!overlay) return

      overlay.style.cssText =
        'background: rgba(20, 20, 20, 0.5) !important; opacity: 1 !important; backdrop-filter: blur(8px) !important; -webkit-backdrop-filter: blur(8px) !important;'
      modal.style.cssText = 'background: #ffffff !important;'

      if (!this.overlayClickHandler) {
        this.overlayClickHandler = (e) => {
          e.stopPropagation()
          e.stopImmediatePropagation()
          e.preventDefault()
          return false
        }
      }

      overlay.addEventListener('click', this.overlayClickHandler, true)
    },
    cleanupOverlayHandler() {
      if (!this.overlayClickHandler) return

      const overlay = document.querySelector(
        '.th-modal-wrapper .th-modal-overlay'
      )
      if (overlay) {
        overlay.removeEventListener('click', this.overlayClickHandler, true)
      }
    },
    handleModalClose() {
      if (!this.allowClose) {
        this.$nextTick(() => {
          this.$thModal.show('session-expired-modal')
        })
      }
    },
    trackLogout() {
      this.allowClose = true
      this.$thModal.hide('session-expired-modal')

      AuthService.resetSessionExpiredModalFlag()
    }
  }
}
</script>

<style scoped>
.session-expired-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.session-expired-title {
  margin: 0;
  text-align: left;
}

.session-expired-message {
  margin: 0;
  color: #6d7184;
}

:deep(.session-expired-body) {
  padding-top: 2rem !important;
}

:deep(.session-expired-modal .th-modal-header .el-button) {
  display: none;
}

:deep(.session-expired-modal .th-modal-header:empty) {
  display: none;
  padding: 0;
}
</style>

<!-- Teleport moves footer into #th-modals; scoped :deep() may not apply there -->
<style>
.session-expired-modal.th-modal .th-modal-footer > * {
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
}

.session-expired-modal.th-modal .th-modal-footer .el-button {
  margin: 0 !important;
}
</style>
